import { api } from "@/lib/api";

const KEY = "jp_attribution";
const AI_ENGINES = [
  ["chatgpt", /(^|\.)(chatgpt\.com|chat\.openai\.com|openai\.com)$/], ["perplexity", /(^|\.)perplexity\.ai$/], ["claude", /(^|\.)claude\.ai$/],
  ["gemini", /(^|\.)gemini\.google\.com$/], ["copilot", /(^|\.)(copilot\.microsoft\.com|bing\.com)$/], ["deepseek", /(^|\.)deepseek\.com$/],
  ["meta_ai", /(^|\.)meta\.ai$/], ["you", /(^|\.)you\.com$/],
];
const SEARCH = /(^|\.)(google|duckduckgo|yahoo|baidu|yandex|ecosia)\./;

function classify(refHost, utm) {
  const src = (utm.utm_source || "").toLowerCase();
  const ai = AI_ENGINES.find(([name, rx]) => rx.test(refHost) || src.includes(name));
  if (ai) return { channel: "ai_referral", ai_engine: ai[0] };
  if (utm.utm_source) return { channel: utm.utm_medium || "campaign", ai_engine: null };
  if (!refHost) return { channel: "direct", ai_engine: null };
  if (SEARCH.test(refHost)) return { channel: "organic_search", ai_engine: null };
  return { channel: "referral", ai_engine: null };
}

export function captureVisit() {
  if (sessionStorage.getItem("jp_visit_logged")) return;
  sessionStorage.setItem("jp_visit_logged", "1");
  const params = new URLSearchParams(window.location.search);
  const utm = Object.fromEntries(["utm_source", "utm_medium", "utm_campaign"].map((k) => [k, (params.get(k) || "").slice(0, 80)]).filter(([, v]) => v));
  let refHost = "";
  try { refHost = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, "") : ""; } catch (_) { refHost = ""; }
  if (refHost && refHost.endsWith("jobpedestal.com")) refHost = "";
  const touch = { ...classify(refHost, utm), referrer_host: refHost.slice(0, 120), landing_path: window.location.pathname.slice(0, 200), ...utm, at: new Date().toISOString() };
  if (!localStorage.getItem(KEY)) localStorage.setItem(KEY, JSON.stringify(touch));
  api.post("/analytics/visit", touch).catch(() => {});
}

export function getAttribution() {
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch (_) { return null; }
}
